$ ->
  if $('body').is('.blog-page')
    $('.search-form').on 'submit', ->
      $('button', this).hide()
      $('.search-spinner', this).show()
